var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "customer-bankdrafts-view" },
    [
      _c("LfHeaderTitleComponent", {
        staticClass: "header-title",
        attrs: { title: _vm.$t("views.billing_customer_bankdrafts.title") },
      }),
      _vm.totals && _vm.totals.length
        ? _c("LfTotalsComponent", { attrs: { items: _vm.totals } })
        : _vm._e(),
      _vm.renderGrid && !_vm.showSpinnerLayer
        ? _c("GridTable", {
            ref: "grid",
            attrs: {
              itemsData: _vm.serverSideData,
              gridConfiguration: _vm.gridConfiguration,
              toolbarOptions: _vm.toolbarOptionsCustom,
              contextMenuItems: _vm.contextMenuItems,
              listName: _vm.listConfiguration["Alias"],
              context: _vm.context,
              archivedFilter: _vm.archivedSelectedOption,
              commandClick: _vm.onCommandClick,
              checkboxSelectColumn: true,
              usePersistSelection: true,
              excelExportedFileName: "Cobros a Clientes",
              useServerPagination: _vm.useServerPagination,
              itemsDataExport: _vm.serverSideExportData,
            },
            on: {
              toolbarClicked: _vm.onToolbarClicked,
              customToolbarContextMenuClick:
                _vm.onCustomToolbarContextMenuClick,
              gridActionChange: _vm.gridActionChange,
              gridExportData: _vm.gridExportData,
            },
          })
        : _vm._e(),
      _c("ejs-contextmenu", {
        staticClass: "context-menu-component e-contextmenu-archived",
        attrs: {
          id: _vm.idContextMenu,
          items: _vm.invoicesArchivedContextMenuItemsParsed,
          select: _vm.onInvoicesArchivedClick,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }